import { Button, Flex } from "antd";
import React, { useState } from "react";
import CustomHeader from "../../../components/header/CustomHeader";
import MiniStats from "./components/MiniStats";
import { useParams } from "react-router-dom";
import OperatorPanel from "./components/OperatorPanel";
import { useAuth } from "../../../store/context/AuthContext";
import { IconFileTypeCsv, IconFileTypeXls } from "@tabler/icons-react";
import axios from "axios";
import api from "../../../api";
import Cookies from "universal-cookie";
import { useToast } from "../../../components/toast/toast";
import dayjs from "dayjs";
import { hasPerm } from "../../../utilities/permission";
const cookies = new Cookies();

const CallCenterDetail = () => {
  const { id } = useParams();
  const [refreshKey, setRefreshKey] = useState(0);
  const { user } = useAuth();
  const toast = useToast();

  const download = async () => {
    if (!id) return;

    const token = cookies.get("access_token");
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/call-center/export`,
      {
        params: { list_id: id },
        responseType: "blob",
        withCredentials: true,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      },
    );

    // ❗ content-type шалгах
    const ct = res.headers?.["content-type"] || "";
    if (
      !ct.includes(
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      )
    ) {
      // серверээс алдаа JSON/HTML ирсэн тохиолдолд
      try {
        const text = await res.data.text(); // Blob -> text
        const err = JSON.parse(text);
        // console.error("Export error:", err);
        // TODO: toast.error(err.message || "Экспорт амжилтгүй");
      } catch {
        // text() амжилтгүй бол ерөнхий алдаа
        toast("Экспорт амжилтгүй боллоо", "error");
      }
      return;
    }

    const ts = dayjs().format("YYYYMMDD_HHmmss");
    const blob = new Blob([res.data], { type: ct });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Grandlotto_${ts}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <Flex vertical gap={"10px"}>
      <CustomHeader
        title={"Дуудлагын дэлгэрэнгүй"}
        rightSide={
          hasPerm(user, "EXPORT_CALL_LIST") && (
            <Button
              variant="dashed"
              color="primary"
              style={{ padding: "0 30px" }}
              onClick={download}
            >
              <IconFileTypeXls stroke={1.5} size={18} />
              Тайлан татах
            </Button>
          )
        }
      />
      <MiniStats listId={id} refreshKey={refreshKey} />
      {hasPerm(user, "CALL_AGENT") && (
        <OperatorPanel listId={id} setRefreshKey={setRefreshKey} />
      )}
    </Flex>
  );
};

export default CallCenterDetail;
